import { ProgramSearchResultModel, UserModel } from '../../models';
import { BehaviorSubject, Observable } from 'rxjs';

export abstract class BaseUserService {
  public user: BehaviorSubject<UserModel>;

  public readonly defaultUser: UserModel;

  public abstract updateUser(user: UserModel): Observable<any>;

  public abstract updateDashboardPrograms(dashboardPrograms: ProgramSearchResultModel[]): Observable<any>;

  public abstract removeDashboardProgram(programUuid: string): Observable<any>;

  public abstract refreshUser(baseUrl: string): Observable<any>;

  public abstract getCurrentUser(includeFields?: string[]): Observable<UserModel>;

  public abstract getUserNidFromJwt();

  public abstract getCurrentUserAciResults(baseUrl: string, uuid: string);
}
